module.exports = __webpack_public_path__ + "img/Artboard 3.ffda740b.png";